<!--
   Copyright (C) GridGain Systems. All Rights Reserved.
   _________        _____ __________________        _____
   __  ____/___________(_)______  /__  ____/______ ____(_)_______
   _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
   / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
   \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
-->
<ng-template #unknownErrorTemplate>Value is invalid</ng-template>
<ng-template gmcError="required" [default]="true" let-label="label">
  <span gta="missing_input_error">{{ label }} is required</span>
</ng-template>
<ng-template gmcError="email" [default]="true">
  <span gta="invalid_email_error">Invalid email</span>
</ng-template>
<ng-template gmcError="passwordsMatch" [default]="true">
  <span gta="pwd_mismatch_error">Passwords don't match</span>
</ng-template>
<ng-template gmcError="server" [default]="true" let-control="control">
  <span gta="server_error">{{ control.getError('server') }}</span>
</ng-template>
<ng-template gmcError="auth" [default]="true" let-control="control">
  <span gta="auth_error">{{ control.getError('auth') }}</span>
</ng-template>
<ng-template gmcError="min" [default]="true" let-control="control">
  Should be ≥ {{ $any(control.errors)?.min?.min }}
</ng-template>
<ng-template gmcError="max" [default]="true" let-control="control">
  Should be ≤ {{ $any(control.errors)?.max?.max }}
</ng-template>
<ng-template gmcError="notInteger" [default]="true">Should be integer</ng-template>
@if ((error$ | async)!; as error) {
  <ng-container
    *ngTemplateOutlet="
      getErrorTemplate(error) || unknownErrorTemplate;
      context: { $implicit: error, error: control.errors?.[error], label: label, control: control }
    "
  ></ng-container>
}
<ng-template gmcError="ignite3xCredentials" [default]="true">Don't use ":"</ng-template>
<ng-template gmcError="children" [default]="true">Some values are invalid</ng-template>
